(function($, Drupal, cookies) {
  Drupal.behaviors.accessibility_settings = {
    attach: function (context, settings) {
      // get current value
      //var $text_size = $.cookie('a-text-size');
      var $text_size = cookies.get('a-text-size');

      if(typeof $text_size !== 'undefined') {
        $('select[name=font-size]').val($text_size);
        $('#preview p').css('font-size', $text_size)
      }

      //var $letter_spacing = $.cookie('a-letter-spacing');
      var $letter_spacing = cookies.get('a-letter-spacing');

      if(typeof $letter_spacing !== 'undefined') {
        $('select[name=letter-spacing]').val($letter_spacing);
        $('#preview p').css('letter-spacing', $letter_spacing)
      }

      $('#accessibility-form select').change(function(e) {
        e.preventDefault();
        var $name = $(this).attr('name');
        var $val = $(this).val();
        $('#preview p').css($name, $val);

        if($name == 'font-size') {
          $('#preview p').css('line-height', $val);
        }
      });

      $('#reset').click(function(e) {
        e.preventDefault();
        $('select[name=font-size]').val('1.3em');
        $('select[name=letter-spacing]').val('normal');

        resetValues();
        return false;
      });

      $('#accessibility-form').submit(function(e) {
        //console.log('asfffa');
        e.preventDefault();
        var $text_size = $('select[name=font-size]').val();
        var $letter_spacing = $('select[name=letter-spacing]').val();
        
        cookies.set('a-text-size', $text_size);
        cookies.set('a-letter-spacing', $letter_spacing);

        //$.cookie('a-text-size', $text_size);
        //$.cookie('a-letter-spacing', $letter_spacing);

        /*
        var $message = '<section id="messages">'
            + '<div class="messages status">'
            + 'Saved</div>'
            + '</section>'
        $('#main-content').prepend($message);
        */

        // refresh page
        location.reload();
      })

      function resetValues() {
        $('#preview p').css('font-size', '1.3em')
          .css('line-height', '1.3em')
          .css('letter-spacing', 'normal');
      }
    }
  };
})(jQuery, Drupal, window.Cookies);
